import React, { useEffect, useState } from 'react';
import { Newspaper, ExternalLink, Loader2, Calendar } from 'lucide-react';
import { getNews } from '../services/cms';
import { useTexts } from '../context/TextsContext';

const formatDate = (iso) => {
  if (!iso) return '';
  try { return new Date(iso).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }); }
  catch (_) { return ''; }
};

const News = () => {
  const { t } = useTexts();
  const [items, setItems] = useState(null);

  useEffect(() => { getNews().then(setItems).catch(() => setItems([])); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 py-10 min-h-[60vh]" data-testid="news-page">
      <h1 className="font-display font-700 text-4xl text-foreground mb-2 flex items-center gap-3"><Newspaper className="w-8 h-8 text-primary" /> {t('news_title', 'Actualités')}</h1>
      <p className="text-muted-foreground font-600 mb-10 max-w-2xl">{t('news_intro', 'Les nouvelles de Citytoon, de ses webtoons et de ses projets.')}</p>

      {items === null ? (
        <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
      ) : items.length === 0 ? (
        <p className="text-muted-foreground font-600">Les actualités ne sont pas disponibles pour le moment.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((n) => (
            <a key={n.id} href={n.link} target="_blank" rel="noreferrer noopener" data-testid={`news-card-${n.id}`}
              className="card-hover group bg-card rounded-2xl overflow-hidden border border-border flex flex-col">
              {n.image && (
                <div className="aspect-[16/10] overflow-hidden bg-muted">
                  <img src={n.image} alt={n.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
              )}
              <div className="p-4 flex flex-col flex-1">
                <h2 className="font-display font-700 text-base leading-snug line-clamp-2 mb-2 group-hover:text-primary transition-colors">{n.title}</h2>
                {n.excerpt && <p className="text-sm text-foreground/70 font-600 line-clamp-3 mb-3">{n.excerpt}</p>}
                <span className="mt-auto inline-flex items-center gap-1.5 text-primary font-800 text-sm" data-testid={`news-link-${n.id}`}>
                  Lire plus sur Citytoon.org <ExternalLink className="w-3.5 h-3.5" />
                </span>
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default News;
